<template>
  <div class="goods-list">
    <div class="top-bar">
      <el-button type="primary" size="small" @click="showCreateGoodsDrawer">新增商品</el-button>
    </div>
    <el-table :data="goodsList" border size="mini" v-loading="loading">
      <el-table-column prop="id" label="商品ID" width="70"></el-table-column>
      <el-table-column prop="image" label="商品主图" width="100" align="center">
        <template slot-scope="scope">
          <img :src="config.imageDisplayBaseUrl+scope.row.image_1" class="goods-image">
        </template>
      </el-table-column>
      <el-table-column prop="category_name" label="所属分类"></el-table-column>
      <el-table-column prop="name" label="商品名称"></el-table-column>
      <el-table-column prop="name_e" label="英文名称"></el-table-column>
      <el-table-column prop="price" label="售价" width="100"></el-table-column>
      <el-table-column prop="specification" label="规格"></el-table-column>
      <el-table-column prop="status" label="显示状态" width="100" align="center">
        <template slot-scope="scope">
          {{scope.row.status === 0?'隐藏':'显示'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="showHideGoods(scope.$index,scope.row)">{{scope.row.status*1===0?'显示':'隐藏'}}</el-button>
          <el-button type="text" size="mini" @click="handleEditGoods(scope.row)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm title="确定删除该商品吗？" @confirm="deleteGoods(scope.row.id)">
            <el-button type="text" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="g-pagination-wrap">
      <el-pagination background layout="total, prev, pager, next" :total=total :current-page.sync="page" :page-size="7" @current-change="handlePageChange"></el-pagination>
    </div>
    <el-drawer title="新增商品" :visible.sync="drawer.createGoods" direction="rtl" size="600px" :wrapperClosable="false">
      <createGoods @cancel="drawer.createGoods = false" @success="handelCreateGoodsSuccess" :random="refresh.create" />
    </el-drawer>
    <el-drawer title="编辑商品" :visible.sync="drawer.editGoods" direction="rtl" size="600px" :wrapperClosable="false" v-if="activeGoodsRow !== undefined">
      <editGoods :id="activeGoodsRow.id" @cancel="drawer.editGoods = false"  @success="handelEditGoodsSuccess"/>
    </el-drawer>
  </div>
</template>

<script>
import { config } from '@/self/config.js'
import createGoods from '@/components/admin/goods/CreateGoods.vue'
import editGoods from '@/components/admin/goods/EditGoods.vue'
export default {
  components: {
    createGoods,
    editGoods
  },
  data () {
    return {
      activeGoodsRow: undefined,
      loading: false,
      config: config,
      page: 1,
      total: 0,
      goodsList: [],
      drawer: {
        createGoods: false,
        editGoods: false
      },
      refresh: {
        create: 0
      }
    }
  },
  methods: {
    showCreateGoodsDrawer () {
      this.refresh.create = this.randomNumber()
      this.drawer.createGoods = true
    },
    randomNumber () {
      const timestamp = Date.parse(new Date())
      return timestamp
    },
    handelCreateGoodsSuccess () {
      this.drawer.createGoods = false
      this.getGoodsList(this.page)
    },
    handelEditGoodsSuccess () {
      this.drawer.editGoods = false
      this.getGoodsList(this.page)
    },
    getGoodsList (page) {
      const that = this
      that.loading = true
      that.axios.get('admin/goods?page=' + page).then(function (resp) {
        if (resp.data.error === 0) {
          that.goodsList = resp.data.list
          that.total = resp.data.total
          that.loading = false
        }
      })
    },
    deleteGoods (id) {
      const that = this
      that.axios.delete('admin/goods/' + id).then(function (resp) {
        that.$message.success('操作成功')
        that.getGoodsList(that.page)
      })
    },
    handleEditGoods (row) {
      this.activeGoodsRow = row
      this.drawer.editGoods = true
    },
    handlePageChange (page) {
      this.getGoodsList(page)
    }
  },
  mounted () {
    this.getGoodsList(1)
  }
}
</script>

<style scoped>
.goods-list{
  box-sizing: border-box;
  padding: 30px 20px;
}
.top-bar{
  margin-bottom: 15px;
}
.goods-image{
  max-width: 70px;
  max-height: 70px;
}
</style>
